import { Asset } from 'expo-asset';

/** V transparente (concept-06) — precarga en index.ts y BrandWatermark. */
export const VUELTO_V_MARK = require('./assets/vuelto-v-mark.png');

/** Icono cuadrado de app (launcher / auth / sidebar). */
export const VUELTO_NEGOCIO_ICON = require('./assets/icon2.png');

/** URI del PNG en web y nativo (Image.resolveAssetSource no existe en RN Web). */
export function getVueltoVMarkUri(): string {
  return Asset.fromModule(VUELTO_V_MARK).uri;
}
